import { api, API_PREFIX } from './client'
import type { SignupRequest, SignupResponse } from '../../types/api'

/** POST /auth/signup (new) — public self-serve signup. */
export async function signup(body: SignupRequest): Promise<SignupResponse> {
  const res = await api.post<SignupResponse>(`${API_PREFIX}/auth/signup`, body)
  return res.data
}
